import { useContext } from 'react';
import usePeriods from '../../../state/hooks/usePeriods';
import MetricsInspectionContext from '../../../state/context';

export const SCATTER_POINTS_LIMIT = 100;

const usePayload = () => {
  const {
    state: {
      metricName,
      filters: { team, label, contributor, service = [], repo = [] }
    }
  } = useContext(MetricsInspectionContext);
  const { lastPeriod } = usePeriods();

  const filters = {
    requested_metrics: [
      { name: metricName, agg: 'raw', limit: SCATTER_POINTS_LIMIT }
    ],
    time_ranges: [lastPeriod],
    roll_up: 'custom',
    group_by: 'organization',
    ...(team && { team_ids: [team.id] }),
    ...(label && { labels: [label] }),
    ...(contributor && { contributor_ids: [contributor.id] }),
    ...(service.length && { service_ids: service.map(({ id }) => id) }),
    ...(repo.length && { repository_ids: repo.map(({ id }) => id) })
  };
  const dependencies = [
    team?.id,
    lastPeriod.before,
    lastPeriod.after,
    label,
    repo,
    contributor?.id,
    service
  ];

  return {
    filters,
    dependencies
  };
};

export default usePayload;
